import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import StepCard from "./StepCard";

const numCircleStyle = {
  width: 56,
  height: 56,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  cursor: "pointer",

  background:
    "linear-gradient(#FFF8E1, #FFF8E1) padding-box, linear-gradient(90deg, transparent, transparent) border-box",

  border: "5px solid transparent",
  boxShadow: "0 0 10px #0000000D",
  transition: "0.3s",
};

const numberStyle = {
  fontSize: "1.5rem",
  fontWeight: 600,
  color: "#000000DE",
};

const iconCircleStyle = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  border: "4px solid #E7E4FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#fff",
};

const verticalLine = {
  width: "1px",
  height: 28,
  backgroundColor: "#0000001F",
};

const StepColumn = ({ step, isLast }) => {
  return (
    <Box
      className="step-root"
      sx={{
        width: 241,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",

        "&:hover .circle": {
          background:
            "linear-gradient(#FFF8E1, #FFF8E1) padding-box, linear-gradient(90deg, #FF7FAC, #5834BA) border-box",
        },

        "&:hover .number": {
          background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        },
      }}
    >
      {/* Circle and Icon */}
      <Box>
        {/* Circles (01, 02, ...) */}
        <Box className="circle" sx={numCircleStyle}>
          <Typography className="number" sx={numberStyle}>
            {step.number}
          </Typography>
        </Box>

        {/* Steps between the icons  */}
        {!isLast && (
          <Box
            sx={{
              position: "absolute",
              top: 28,
              right: -10, // Move icon left and right
              transform: "translate(50%, -50%)",
              zIndex: 3,
            }}
          >
            <Box sx={iconCircleStyle}>
              <ChevronRightIcon />
            </Box>
          </Box>
        )}
      </Box>

      {/* Vertical Line */}
      <Box sx={{ ...verticalLine }} />

      {/* Cards */}
      <Box sx={{ width: "100%" }}>
        <StepCard {...step} />
      </Box>
    </Box>
  );
};

export default StepColumn;
